export const topicsData = [
  { id: 1, name: '热门电影', count: '2.3万', hot: true, icon: 'ri-fire-line' },
  { id: 2, name: '最新剧集', count: '1.8万', hot: true, icon: 'ri-flashlight-line' },
  { id: 3, name: '动作大片', count: '1.5万', hot: false, icon: 'ri-swap-box-line' },
  { id: 4, name: '悬疑推理', count: '1.2万', hot: true, icon: 'ri-search-eye-line' },
  { id: 5, name: '喜剧搞笑', count: '9.8k', hot: false, icon: 'ri-emotion-happy-line' },
  { id: 6, name: '科幻奇幻', count: '8.5k', hot: false, icon: 'ri-rocket-line' },
  { id: 7, name: '古装仙侠', count: '7.2k', hot: true, icon: 'ri-sword-line' },
  { id: 8, name: '综艺娱乐', count: '6.8k', hot: false, icon: 'ri-live-line' },
  { id: 9, name: '动漫番剧', count: '5.4k', hot: false, icon: 'ri-ghost-line' },
];

export const faqData = [
  {
    id: 1,
    question: '色影视需要注册或付费才能观看吗？',
    answer: '完全不需要。色影视所有高清电影、电视剧、综艺节目全部免费在线观看，无需注册账号，无需支付任何费用，打开即看，享受纯粹观影体验。',
  },
  {
    id: 2,
    question: '视频画质怎么样？支持超清吗？',
    answer: '平台所有内容均提供超清画质（1080P及以上），部分热门大片更支持4K分辨率。我们采用先进的视频编码技术，在保证画质的同时优化带宽占用，让你看得清、看得爽。',
  },
  {
    id: 3,
    question: '播放会卡顿吗？需要缓冲很久吗？',
    answer: '色影视部署了智能CDN加速节点，覆盖全国主要城市。视频加载速度经过深度优化，绝大多数用户在正常网络环境下即可实现即点即播，告别长时间缓冲等待。',
  },
  {
    id: 4,
    question: '每天更新多少内容？新片多久能上线？',
    answer: '我们保持每日更新，热门电视剧同步跟播、新上映电影第一时间上线。平均每日新增影视资源超过50部，涵盖电影、电视剧、综艺、动漫等全品类，确保你永不剧荒。',
  },
  {
    id: 5,
    question: '手机、平板、电脑都可以看吗？',
    answer: '色影视采用响应式设计，完美适配手机、平板、笔记本电脑和台式机等全平台设备。无论你是在通勤路上用手机追剧，还是在家用大屏观影，都能获得流畅一致的观看体验。',
  },
  {
    id: 6,
    question: '观看时有广告干扰吗？',
    answer: '我们坚持极简观影理念，页面设计简洁清爽，最大限度减少广告干扰。不弹出遮挡式广告、不强制观看广告视频，让你沉浸式享受每一部影视作品。',
  },
];

export const commentsData = [
  {
    id: 1,
    name: '电影发烧友小王',
    time: '3天前',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20man%20portrait%20simple%20minimal%20style%20clean%20background%20warm%20tone%20professional%20headshot&width=80&height=80&seq=avatar-01&orientation=squarish',
    content: '用色影视看了一整年的电影了，画质是真的好，而且更新速度没话说，新上映的大片基本都能很快看到。推荐给身边好多朋友了！',
  },
  {
    id: 2,
    name: '追剧小达人',
    time: '5天前',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20woman%20portrait%20simple%20minimal%20style%20clean%20background%20warm%20tone%20casual%20headshot&width=80&height=80&seq=avatar-02&orientation=squarish',
    content: '终于找到一个不用注册就能看的平台了！之前被各种收费网站烦死了，色影视真良心，每天下班回来追两集剧太幸福了。',
  },
  {
    id: 3,
    name: '老李说影视',
    time: '1周前',
    avatar: 'https://readdy.ai/api/search-image?query=middle%20aged%20Chinese%20man%20portrait%20simple%20minimal%20style%20clean%20background%20warm%20tone%20friendly%20headshot&width=80&height=80&seq=avatar-03&orientation=squarish',
    content: '资源太全了！我追的几部冷门老剧居然都能找到完整版，而且画质清晰不卡。收藏夹已经放不下了，色影视名副其实。',
  },
  {
    id: 4,
    name: '周末影院',
    time: '1周前',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20couple%20portrait%20simple%20minimal%20style%20clean%20background%20warm%20tone%20casual%20headshot&width=80&height=80&seq=avatar-04&orientation=squarish',
    content: '每周五晚上和女朋友一起用色影视看电影已经成了固定节目。资源新、画质好、不卡顿，比开会员的APP都好用，强烈推荐！',
  },
  {
    id: 5,
    name: '剧荒终结者',
    time: '2周前',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20woman%20portrait%20simple%20minimal%20style%20clean%20background%20warm%20tone%20smiling%20headshot&width=80&height=80&seq=avatar-05&orientation=squarish',
    content: '之前剧荒的时候朋友推荐了色影视，打开一看惊了，热门剧集全都有，综艺也特别全。现在每天都要上来看看更新了什么，根本停不下来。',
  },
];

export const mediaData = [
  {
    id: 1,
    title: '年度必看动作巨制，燃炸银幕',
    category: '动作大片',
    views: '128.5万',
    rating: '9.2',
    image: 'https://readdy.ai/api/search-image?query=epic%20action%20movie%20scene%20with%20intense%20fight%20choreography%20dramatic%20lighting%20cinematic%20composition%20warm%20golden%20tones%20high%20contrast%20professional%20movie%20poster%20style%20dark%20background%20with%20flame%20accents&width=800&height=450&seq=media-01&orientation=landscape',
  },
  {
    id: 2,
    title: '悬疑烧脑神剧，每一秒都是反转',
    category: '悬疑推理',
    views: '96.3万',
    rating: '9.5',
    image: 'https://readdy.ai/api/search-image?query=suspense%20thriller%20movie%20scene%20mysterious%20atmosphere%20rainy%20night%20city%20street%20noir%20style%20cinematic%20lighting%20deep%20shadows%20warm%20street%20lamp%20glow%20professional%20movie%20poster%20composition&width=800&height=450&seq=media-02&orientation=landscape',
  },
  {
    id: 3,
    title: '笑到停不下来的口碑喜剧',
    category: '喜剧搞笑',
    views: '203.7万',
    rating: '8.9',
    image: 'https://readdy.ai/api/search-image?query=bright%20comedic%20movie%20scene%20warm%20lighting%20happy%20atmosphere%20colorful%20visual%20style%20sunlit%20setting%20cinematic%20composition%20feel%20good%20vibe%20professional%20movie%20poster%20style%20cheerful%20mood&width=800&height=450&seq=media-03&orientation=landscape',
  },
  {
    id: 4,
    title: '国产古装巨制，美到每一帧',
    category: '古装仙侠',
    views: '156.2万',
    rating: '9.3',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20scene%20elegant%20ancient%20palace%20setting%20flowing%20silk%20costumes%20warm%20lantern%20lighting%20cinematic%20composition%20rich%20golden%20and%20red%20tones%20professional%20movie%20poster%20style%20dreamy%20atmosphere&width=800&height=450&seq=media-04&orientation=landscape',
  },
  {
    id: 5,
    title: '科幻巨献，开启星际冒险之旅',
    category: '科幻奇幻',
    views: '87.4万',
    rating: '9.1',
    image: 'https://readdy.ai/api/search-image?query=epic%20science%20fiction%20movie%20scene%20futuristic%20space%20setting%20nebulae%20and%20stars%20cinematic%20composition%20dramatic%20lighting%20deep%20blue%20and%20warm%20gold%20contrast%20professional%20movie%20poster%20style%20grand%20scale&width=800&height=450&seq=media-05&orientation=landscape',
  },
];

export const indexData = [
  { id: 1, title: '动作电影合集', count: '328部', desc: '热血打斗、枪战飞车，肾上腺素飙升' },
  { id: 2, title: '国产剧精选', count: '256部', desc: '品质国剧，口碑与热度齐飞' },
  { id: 3, title: '韩剧专区', count: '189部', desc: '浪漫爱情、悬疑犯罪，韩流精选' },
  { id: 4, title: '美剧热播', count: '215部', desc: '高能剧情、精品制作，一季追到底' },
  { id: 5, title: '动画电影馆', count: '142部', desc: '全年龄向动画佳作，老少皆宜' },
  { id: 6, title: '纪录片精选', count: '98部', desc: '探索世界、了解真相，纪实之美' },
  { id: 7, title: '恐怖惊悚夜', count: '167部', desc: '深夜档精选，胆大者入' },
];

export const aboutData = {
  title: '关于色影视',
  description: '色影视成立于2024年，是一个专注于高清影视内容聚合与在线观看的平台。我们汇聚了海量高清免费电影、高清免费电视剧、高清免费综艺节目，致力于为广大影视爱好者提供超清画质、流畅不缓冲的观影体验。无需注册付费，打开即看，每日更新最新热门影视剧集。色影视始终坚持以用户观影体验为核心，持续优化播放技术与内容覆盖，让每一位用户都能在这里找到心仪的影视作品。',
  stats: [
    { label: '影视资源', value: '50,000+' },
    { label: '日活用户', value: '120万+' },
    { label: '日均更新', value: '50+部' },
    { label: '覆盖品类', value: '15个' },
  ],
};

export const updatesData = [
  {
    id: 1,
    date: '2026-07-31',
    title: '全新播放器上线，画质与流畅度全面提升',
    desc: '全新自研播放引擎正式上线，支持智能码率自适应与HDR画质，观影体验大幅提升。',
  },
  {
    id: 2,
    date: '2026-07-28',
    title: '新增100+部4K超清电影资源',
    desc: '本月再次扩充4K片源库，涵盖动作、科幻、古装等多品类，超清观影更加畅快。',
  },
  {
    id: 3,
    date: '2026-07-25',
    title: '暑期档热门剧集同步上线',
    desc: '多部暑期档热门电视剧已同步更新，追剧不等待，第一时间看最新剧集。',
  },
  {
    id: 4,
    date: '2026-07-20',
    title: '移动端体验全面优化',
    desc: '针对手机和平板设备进行了全面的UI与性能优化，移动追剧更加流畅顺滑。',
  },
  {
    id: 5,
    date: '2026-07-15',
    title: '综艺频道内容扩容，热门综艺全覆盖',
    desc: '综艺频道新增多档热门节目完整版，涵盖音乐竞演、真人秀、脱口秀等类型。',
  },
  {
    id: 6,
    date: '2026-07-10',
    title: 'CDN节点扩展至全国50+城市',
    desc: '智能加速网络进一步扩展，更多地区用户可享受即点即播的流畅观影体验。',
  },
  {
    id: 7,
    date: '2026-07-05',
    title: '动漫番剧专区上线',
    desc: '全新动漫番剧专区正式上线，覆盖热血、治愈、搞笑、恋爱等多类型，日漫国漫全覆盖。',
  },
  {
    id: 8,
    date: '2026-07-01',
    title: '色影视2.0版本发布，界面与功能全面焕新',
    desc: '历时三个月的改版升级，全新视觉设计、更智能的推荐算法、更流畅的观影体验。',
  },
];

export const cardsData = [
  {
    id: 1,
    title: '暑期档必看大片盘点',
    category: '电影',
    desc: '盘点今年暑期档最值得期待的十部大片，动作、科幻、喜剧一网打尽。',
    image: 'https://readdy.ai/api/search-image?query=summer%20movie%20collage%20style%20warm%20cinematic%20composition%20golden%20sunset%20lighting%20film%20reel%20elements%20dramatic%20atmosphere%20professional%20editorial%20design%20rich%20warm%20colors&width=600&height=400&seq=card-01&orientation=landscape',
  },
  {
    id: 2,
    title: '零差评国产剧推荐',
    category: '电视剧',
    desc: '口碑炸裂的国产良心剧，从剧情到演技全线在线，每一部都值得二刷。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20elegant%20scene%20traditional%20costume%20warm%20lighting%20cinematic%20composition%20soft%20focus%20rich%20red%20and%20gold%20tones%20professional%20editorial%20photography%20style&width=600&height=400&seq=card-02&orientation=landscape',
  },
  {
    id: 3,
    title: '那些年我们追过的经典韩剧',
    category: '韩剧',
    desc: '从《来自星星的你》到近年爆款，重温那些让人心动不已的韩剧经典。',
    image: 'https://readdy.ai/api/search-image?query=romantic%20Korean%20drama%20scene%20cherry%20blossom%20spring%20setting%20warm%20pastel%20tones%20soft%20natural%20lighting%20cinematic%20composition%20dreamy%20atmosphere%20professional%20editorial%20photography&width=600&height=400&seq=card-03&orientation=landscape',
  },
  {
    id: 4,
    title: '科幻迷的终极片单',
    category: '科幻',
    desc: '从经典硬核科幻到脑洞大开的软科幻佳作，满足你对未来的所有想象。',
    image: 'https://readdy.ai/api/search-image?query=futuristic%20science%20fiction%20movie%20scene%20space%20station%20interior%20dramatic%20lighting%20neon%20accents%20cinematic%20composition%20deep%20blues%20and%20warm%20highlights%20professional%20editorial%20design%20style&width=600&height=400&seq=card-04&orientation=landscape',
  },
  {
    id: 5,
    title: '周末宅家必备：高分动画电影',
    category: '动画',
    desc: '精心整理了超高口碑动画电影合集，大人小孩都能找到属于自己的感动。',
    image: 'https://readdy.ai/api/search-image?query=animated%20movie%20scene%20colorful%20fantasy%20world%20warm%20magical%20atmosphere%20soft%20glowing%20lighting%20cinematic%20composition%20playful%20and%20heartwarming%20professional%20editorial%20photography%20style&width=600&height=400&seq=card-05&orientation=landscape',
  },
];

export const contactData = {
  title: '联系我们',
  intro: '如有影视资源推荐、合作咨询或问题反馈，欢迎通过以下方式联系我们。我们珍视每一条来自观影同好的声音。',
  email: 'contact@seyingshi.com',
  wechat: '色影视官方',
  qq: '1234567890',
};

export const appData = {
  title: '色影视 - 随时随地，高清追剧',
  description: '色影视移动端适配已全面优化，无需下载APP，在手机浏览器中打开即可享受与桌面端一致的超清观影体验。全平台同步观影记录，手机、平板、电脑无缝切换。',
  features: ['无需安装', '即开即看', '超清画质', '流畅播放', '全平台适配'],
};

export const featuresData = [
  {
    id: 1,
    title: '超清画质',
    desc: '全站1080P起步，海量4K片源，细节纤毫毕现',
    icon: 'ri-4k-line',
  },
  {
    id: 2,
    title: '流畅不缓冲',
    desc: '智能CDN加速，全国50+城市节点覆盖，即点即播',
    icon: 'ri-speed-up-line',
  },
  {
    id: 3,
    title: '完全免费',
    desc: '无需注册登录，无需付费订阅，打开即看，畅享全部内容',
    icon: 'ri-vip-crown-line',
  },
  {
    id: 4,
    title: '每日更新',
    desc: '平均日更50+部影视资源，热门剧集同步跟播不等待',
    icon: 'ri-calendar-check-line',
  },
  {
    id: 5,
    title: '海量片库',
    desc: '5万+影视资源覆盖电影、电视剧、综艺、动漫全品类',
    icon: 'ri-folders-line',
  },
];

export const rankingData = [
  { id: 1, rank: 1, title: '狂飙', category: '国产剧', hot: '🔥 9.8', trend: 'up' },
  { id: 2, rank: 2, title: '流浪地球2', category: '科幻电影', hot: '🔥 9.6', trend: 'up' },
  { id: 3, rank: 3, title: '漫长的季节', category: '国产剧', hot: '🔥 9.5', trend: 'up' },
  { id: 4, rank: 4, title: '奥本海默', category: '传记电影', hot: '9.4', trend: 'new' },
  { id: 5, rank: 5, title: '三体', category: '科幻剧', hot: '9.3', trend: 'up' },
  { id: 6, rank: 6, title: '孤注一掷', category: '犯罪电影', hot: '9.2', trend: 'up' },
  { id: 7, rank: 7, title: '奔跑吧第十一季', category: '综艺', hot: '9.1', trend: 'down' },
];

export const carouselData = [
  {
    id: 1,
    title: '2026暑期档观影指南',
    subtitle: '精选20部必看大片，这个夏天不剧荒',
    category: '特别策划',
    image: 'https://readdy.ai/api/search-image?query=summer%20movie%20marathon%20cinematic%20collage%20warm%20golden%20sunset%20lighting%20film%20strip%20elements%20dramatic%20atmosphere%20professional%20editorial%20design%20rich%20warm%20colors%20movie%20theater%20vibe&width=1200&height=600&seq=carousel-01&orientation=landscape',
  },
  {
    id: 2,
    title: '国产剧口碑巅峰之作',
    subtitle: '9分以上神剧合集，每一部都值得细细品味',
    category: '剧集推荐',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20elegant%20scene%20ancient%20architecture%20warm%20golden%20light%20cinematic%20composition%20misty%20mountains%20traditional%20aesthetic%20professional%20editorial%20design%20rich%20cultural%20atmosphere&width=1200&height=600&seq=carousel-02&orientation=landscape',
  },
  {
    id: 3,
    title: '周末电影马拉松',
    subtitle: '从动作到悬疑，从喜剧到科幻，一场类型盛宴',
    category: '观影指南',
    image: 'https://readdy.ai/api/search-image?query=cozy%20home%20movie%20night%20warm%20ambient%20lighting%20projector%20screen%20cinematic%20composition%20soft%20glow%20comfortable%20atmosphere%20professional%20editorial%20design%20rich%20warm%20tones%20inviting%20vibe&width=1200&height=600&seq=carousel-03&orientation=landscape',
  },
  {
    id: 4,
    title: '冷门高分电影挖掘',
    subtitle: '那些被埋没的宝藏影片，发现不一样的精彩',
    category: '冷门精选',
    image: 'https://readdy.ai/api/search-image?query=hidden%20gem%20movie%20collection%20artistic%20independent%20film%20aesthetic%20warm%20vintage%20tone%20cinematic%20composition%20film%20reel%20and%20camera%20elements%20professional%20editorial%20design%20rich%20textured%20atmosphere&width=1200&height=600&seq=carousel-04&orientation=landscape',
  },
];